<template>
  <div class="home">
  <Loading v-show="loading"></Loading>
    <div v-show="!loading">
    <img alt="ぶらっしゅとーく" class="logo" src="../assets2/title2.svg">
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading'

export default {
  name: 'Home',
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  components: {
    Loading,
  },
}
</script>
<style scoped>
  .home img {
    display: inline-block;
    position: relative;
    top: 150px;
    width: 500px;
  }

  @font-face {
    font-family: minmoji;
    src: url('https://minmoji.ucda.jp/fontseot/https%3A__brushtalk-5c0f3.web.app_');
    src: local('minmoji'),
        url('https://minmoji.ucda.jp/fontswoff/https%3A__brushtalk-5c0f3.web.app_') format('woff'),
        url('https://minmoji.ucda.jp/fonts/https%3A__brushtalk-5c0f3.web.app_') format('opentype');
  }

  .home {
    font-family: minmoji;
  }
</style>
